module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_24.cb4abb0f.jpg";